import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  Image,
} from '@react-pdf/renderer';
import {
  logoSanlamBase64,
  newLogoSanlamBase64,
} from 'components/DesignationLetter/constants';
import moment from 'moment';
import { FEATURES } from 'features/features';
import * as featureService from 'features/fflip-helpers';

const styles = StyleSheet.create({
  page: {
    padding: 40,
    fontSize: 12,
    lineHeight: 1.5,
  },
  image: {
    textAlign: 'left',
    width: '130px',
    height: '30px',
    padding: '0px',
  },
  newImage: {
    textAlign: 'left',
    width: '220px',
    height: '70px',
    padding: '0px',
    marginLeft: '-20px',
  },
  header: {
    fontWeight: 'bold',
  },
  underline: {
    textDecoration: 'underline',
  },
  rightAlign: {
    textAlign: 'right',
    marginBottom: 10,
  },
  section: {
    marginBottom: 20,
  },
  bodyText: {
    marginBottom: 10,
  },
  table: {
    display: 'flex',
    flexDirection: 'column',
    borderWidth: 1,
    borderColor: '#000',
    marginTop: 20,
    width: '60%',
  },
  tableRow: {
    flexDirection: 'row',
  },
  tableCell: {
    flex: 1,
    borderRightWidth: 1,
    borderBottomWidth: 1,
    borderColor: '#000',
    padding: 4,
  },
  tableCel: {
    flex: 1,
    borderRightWidth: 1,
    borderBottomWidth: 1,
    padding: 4,
  },
  lastCell: {
    borderRightWidth: 0,
  },
  footer: {
    fontSize: '9px',
    marginRight: '50px',
    marginTop: '0px',
    marginBottom: '10px',
    textAlign: 'left',
  },
  footerView: {
    position: 'absolute',
    bottom: 0,
    left: 40,
    right: 40,
    textAlign: 'center',
    fontSize: 10,
    color: 'grey',
  },
  lastView: {
    marginTop: '40px',
  },
  listItemContainer: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    marginBottom: 5,
  },
  bullet: {
    width: 10,
    marginRight: 5,
    fontSize: 10, // Adjust bullet size
  },
  listItemText: {
    fontSize: 12,
  },
  newFooter: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    color: '#000',
    textAlign: 'left',
  },
  newFooterLeft: {
    flex: 1,
    paddingRight: 10,
  },
  newFooterLine1: {
    fontSize: 10,
  },
  newFooterLine2: {
    fontSize: 7.5,
  },
  newFooterBold: {
    fontWeight: 'bold',
  },
  newFooterLegal: {
    fontSize: 6.5,
  },
  newFooterRight: {
    width: 100,
    paddingTop: 12,
  },
  newFooterContactRow: {
    flexDirection: 'row',
    fontSize: 7.5,
  },
  newFooterContactLabel: {
    width: 18,
    fontWeight: 'bold',
  },
  newFooterWeb: {
    fontSize: 7.5,
    marginLeft: 18,
  },
});
const dateNow = moment().format('DD/MM/YYYY');

const SecondExaminationLetter = (props: any) => {
  const renderFooter = () => {
    if (featureService.hasFeature(FEATURES.REBRANDING_EDITIQUE)) {
      return (
        <View style={styles.newFooter}>
          <View style={styles.newFooterLeft}>
            <Text style={styles.newFooterLine1}>
              Assurance Non-Vie {'  •  '} Assurance Vie
            </Text>
            <Text style={styles.newFooterLine2}>
              <Text style={styles.newFooterBold}>SanlamAllianz Maroc</Text>
              {'  |  216, Bd Zerktouni  |  CP : 20000  |  Casablanca, Maroc'}
            </Text>
            <Text style={styles.newFooterLegal}>
              SanlamAllianz Maroc - société anonyme d’assurances et de
              réassurance au capital social de 534.187.400 de DH. Entreprise
              régie par la loi n° 17-99 portant code des assurances. RC
              Casablanca : 22.341. CNSS : 167.8541 - Taxe professionnelle :
              355.11.249 - IF : 01084025 - ICE : 000230054000034
            </Text>
          </View>

          <View style={styles.newFooterRight}>
            <View style={styles.newFooterContactRow}>
              <Text style={styles.newFooterContactLabel}>T</Text>
              <Text>+212 522 42 06 06</Text>
            </View>
            <View style={styles.newFooterContactRow}>
              <Text style={styles.newFooterContactLabel}>F</Text>
              <Text>+212 522 20 60 81</Text>
            </View>
            <Text style={styles.newFooterWeb}>SanlamAllianz.ma</Text>
          </View>
        </View>
      );
    } else if (featureService.hasFeature(FEATURES.FUSION)) {
      return (
        <Text style={styles.footer}>
          Assurance Non-Vie | Assurance Vie | Sanlam Maroc | 216, Bd Zerktouni |
          CP: 20000 | Casablanca, Maroc Sanlam Maroc - société anonyme
          d’assurances et de réassurance au capital social de 534.187.400 de DH.
          Entreprise régie par la loi n° 17-99 portant code des assurances. RC
          Casablanca : 22.341. CNSS : 167.8541 - Taxe professionnelle :
          355.11.249 IF : 01084025 - ICE : 000230054000034 T +212 522 42 06 06 F
          +212 522 20 60 81 sanlam.ma
        </Text>
      );
    } else {
      return (
        <Text style={styles.footer}>
          Assurance Non-Vie | Assurance Vie | Sanlam Maroc | 216, Bd Zerktouni |
          CP: 20000 | Casablanca, Maroc Sanlam Maroc - société anonyme
          d’assurances et de réassurance au capital social de 411.687.400 de DH.
          Entreprise régie par la loi n° 17-99 portant code des assurances. RC
          Casablanca : 22.341. CNSS : 167.8541 - Taxe professionnelle :
          355.11.249 IF : 01084025 - ICE : 000230054000034 T +212 522 42 06 06 F
          +212 522 20 60 81 sanlam.ma
        </Text>
      );
    }
  };
  return (
    <Document>
      <Page style={styles.page}>
        <Image
          style={
            featureService.hasFeature(FEATURES.REBRANDING_EDITIQUE)
              ? styles.newImage
              : styles.image
          }
          src={
            featureService.hasFeature(FEATURES.REBRANDING_EDITIQUE)
              ? newLogoSanlamBase64
              : logoSanlamBase64
          }
        />

        <View style={[styles.section, styles.rightAlign]}>
          <Text> {props.data?.clientInfo?.fullName}</Text>
          <Text> {props.data?.clientInfo?.adress}</Text>
          <Text> {props.data?.clientInfo?.town}</Text>
        </View>
        <View style={[styles.section, styles.rightAlign]}>
          <Text>Casablanca, le {dateNow} </Text>
        </View>

        <View style={[styles.section]}>
          <Text style={[styles.header]}>
            Objet : Lettre Contre Visite Médecin
          </Text>
          <Text style={[styles.header]}>
            Référence Dossier : {props.data.claimNumber}
          </Text>
          <Text style={[styles.header]}>
            Date Survenance : {moment(props.data.lossDate).format('DD/MM/YYYY')}
          </Text>
          <Text style={[styles.header]}>
            N° Mission : {props.data.reference}
          </Text>
          <Text style={[styles.header]}>
            Nom et Prénom Victime : {props.data.victimName}
          </Text>
        </View>
        <Text>{props.data.clientIntro} ,</Text>

        <View style={styles.bodyText}>
          <Text>
            Nous nous permettons de prendre votre attache au sujet de l’affaire
            en objet et vous informons que nous sommes disposés à régler cette
            affaire à l’amiable.
          </Text>
        </View>
        <View style={styles.bodyText}>
          <Text>
            Au cas où vous adhérez à notre proposition, nous vous prions
            {props.data?.adressText} chez notre médecin conseil : Dr.
            {props.data?.expertInfo?.ItemDescription},
            {props.data?.expertInfo?.address},
            {props.data?.expertInfo?.expertTown} et N°
            {props.data?.expertInfo?.cellPhone} muni de cette lettre
            d’introduction et des pièces suivantes :
          </Text>
          <View style={styles.listItemContainer}>
            <Text style={styles.bullet}>•</Text>
            <Text style={styles.listItemText}>Carte d’identité nationale.</Text>
          </View>
          <View style={styles.listItemContainer}>
            <Text style={styles.bullet}>•</Text>
            <Text style={styles.listItemText}>Dossier médical.</Text>
          </View>
          <View style={styles.listItemContainer}>
            <Text style={styles.bullet}>•</Text>
            <Text style={styles.listItemText}>
              Copie du procès-verbal d’enquête.
            </Text>
          </View>
        </View>
        <View style={styles.bodyText}>
          <Text>
            Dès réception des conclusions médicales de ce praticien, nous ne
            manquerons pas de vous informer de nos offres.
          </Text>
        </View>

        <View style={styles.bodyText}>
          <Text>
            Dans l’attente de votre retour, veuillez agréer,
            {props.data.clientIntro}, l’expression de nos salutations
            distinguées.
          </Text>
        </View>
        <View style={styles.lastView}>
          <Text>{props.data.createdBy?.toUpperCase()}</Text>
          <Text>Coordinateur Transaction</Text>
          <Text>216, Bd Zerktouni, Casablanca CP 20000 – MAROC</Text>
        </View>
        <View fixed style={styles.footerView}>
          {renderFooter()}
        </View>
      </Page>
    </Document>
  );
};

export default SecondExaminationLetter;
